// @flow
import React, { useState } from 'react';
import { getRCVersionOptionsFromRCs } from '@streaming-projects/utils';
import { SelectField } from '@src/formik-utils/FormFields';
import { BACKEND_FIELDNAMES } from '@streaming-projects/enums';
import { useFormikContext } from 'formik';
import EstimateRateCardChangeWarningModal from '@components/estimate-commit-details/EstimateRateCardChangeWarningModal';
import { If } from '@presentational/If';

import { STREAMING_PROJECTS_ORG_DETAILS_CONFIG_MAP } from '../config';
import { useRateCardMetaContext } from '../contexts/SPRateCardMetaContextProvider';

export const SPRateCardsContainer = ({
  disableOnFormErrors,
  shouldShowRCChangeModalAndDetailsTooltip = true,
}) => {
  const { initialValues } = useFormikContext();
  const rcVersions = useRateCardMetaContext()?.rate_cards;
  const rcVersionsOptions = getRCVersionOptionsFromRCs(rcVersions, false);
  const { backendFieldName, displayName, tooltip } = STREAMING_PROJECTS_ORG_DETAILS_CONFIG_MAP.get(
    BACKEND_FIELDNAMES.RATE_CARD
  );
  const [isRCChangeWarningModalOpen, setRCChangeWarningModalOpen] = useState(false);

  return (
    <>
      <If test={shouldShowRCChangeModalAndDetailsTooltip}>
        <EstimateRateCardChangeWarningModal
          isOpen={isRCChangeWarningModalOpen}
          setOpen={setRCChangeWarningModalOpen}
        />
      </If>
      <SelectField
        disableOnFormErrors={disableOnFormErrors}
        fieldDisplayName={displayName}
        fieldName={backendFieldName}
        onChange={(event, value) => {
          if (value !== initialValues[backendFieldName]) {
            setRCChangeWarningModalOpen(true);
          }
        }}
        options={rcVersionsOptions}
        tooltip={shouldShowRCChangeModalAndDetailsTooltip ? tooltip : null}
      />
    </>
  );
};
